module.exports = __webpack_public_path__ + "static/integration_img_mobile_425x469-3177f9bddbe9f85e1ad5849a67c4d74c.jpg";